import { Component } from '@angular/core';

@Component({
  selector: 'app-progress',
  imports: [],
  template: `<svg
  width="32"
  height="32"
  viewBox="0 0 31 31"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.31396"
    y="1.26074"
    width="29"
    height="29"
    rx="14.5"
    fill="#C0D4BB"
  />
  <rect
    x="1.31396"
    y="1.26074"
    width="29"
    height="29"
    rx="14.5"
    stroke="#779677"
  />
</svg>
`
})
export class ProgressComponent {

}
